import React from "react";
import styled from "styled-components";

export interface Props {
  onPress?: () => void;
  hideAlert: () => void; // 모달 닫기
  buttonText: string;
  $backgroundColor: string;
  $textColor?: string;
}

const ModalButton: React.FC<Props> = ({
  onPress,
  hideAlert,
  buttonText,
  $backgroundColor,
  $textColor,
}: Props) => {
  return (
    <StyledButton
      $backgroundColor={$backgroundColor}
      onClick={() => {
        hideAlert();
        onPress && onPress();
      }}
      $textColor={$textColor}
    >
      {buttonText}
    </StyledButton>
  );
};

export default ModalButton;

const StyledButton = styled.button<{
  $backgroundColor?: string;
  $textColor?: string;
}>`
  flex: 1;
  height: 48px;
  border: none;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  line-height: 25px;
  letter-spacing: -0.8px;
  color: ${({ $textColor }) => $textColor as string};
  background-color: ${({ $backgroundColor }) => $backgroundColor as string};
`;
